import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Badge, Button, ButtonGroup, Divider, ModalBody, ModalFooter, Stack, Text, useDisclosure } from "@chakra-ui/react";
import { Clipboard, Dev, Icon, IconButton, Label, Modal, Pressable, Profile, Show } from "components";
import { Enums, Mask } from "config";
import { useFiscalNote, useScreens } from "hooks";
import { useNavigate } from "react-router";
import { Loading } from "screens";
import Attach from "./attach";

export default function View({ data, ...props }){

    const { setOrder } = useScreens()
    const fiscal = useFiscalNote(data?.id)
    const status = Enums.FiscalNoteStatus.data(fiscal.data?.status)
    const orderStatus = Enums.OrderStatus.data(fiscal.data?.order?.status)

    const attach = useDisclosure()

    if(fiscal.isLoading) return <Loading text="Carregando dados da nota fiscal..." {...props} />

    return(
    <>
    <Modal title={`Nota fiscal #${fiscal.data?.cod}`} {...props}>
        <ModalBody>
            
            <Accordion>

                {/* Detalhes da nota */}
                <AccordionItem>
                    <AccordionButton>
                        <Text fontSize="xs" fontWeight="bold" children="Detalhes da nota" />
                        <Badge children={status.label} colorScheme={status.colorScheme} mx={2} />
                        <AccordionIcon />
                    </AccordionButton>
                    <AccordionPanel>
                        <Stack spacing={4}>
                            <Label label="Descrição da nota:" children={fiscal.data?.label} />
                            <Label label="Número:" children={<Clipboard children={fiscal.data?.number} />} />
                            <Label label="Código interno:" children={fiscal.data?.cod} />
                            <Show visible={!!fiscal.data?.created_by}><Label label="Emitido/Anexado por:" children={<Profile name={fiscal.data?.created_by?.name} />} /></Show>
                            <Divider />
                            <ButtonGroup size="sm" colorScheme="blue">
                                <Button isDisabled={!fiscal.data?.pdf} onClick={() => window.open(fiscal.data?.pdf?.download_url)} children="Download PDF" leftIcon={<Icon name="pdf" />} />
                                <Button isDisabled={!fiscal.data?.xml} onClick={() => window.open(fiscal.data?.xml?.download_url)} children="Download XML" leftIcon={<Icon name="xml" />} />
                            </ButtonGroup>
                        </Stack>
                    </AccordionPanel>
                </AccordionItem>

                {/* Detalhes do pedido */}
                <Show visible={!!fiscal.data?.order}>
                    <AccordionItem>
                        <AccordionButton>
                            <Text fontSize="xs" fontWeight="bold" children={`Pedido #${fiscal.data?.order?.cod} vinculado`} />
                            <Badge children={orderStatus.label} colorScheme={orderStatus.colorScheme} mx={2} />
                            <AccordionIcon />
                        </AccordionButton>
                        <AccordionPanel>
                            <Stack>
                                <Label label="Código do pedido:" children={fiscal.data?.order?.cod} />
                                <Label label="Cliente:" children={<Profile name={fiscal.data?.order?.consultant?.customer?.name ?? fiscal.data?.order?.distributor_to?.name} />} />
                                <Label label="Valor:" children={`R$ ${Mask.price(fiscal.data?.order?.total_amount)}`} />
                                <Button size="sm" children="Ver detalhes do pedido" onClick={() => setOrder(fiscal.data?.order)} />
                            </Stack>
                        </AccordionPanel>
                    </AccordionItem>
                </Show>

            </Accordion>

        </ModalBody>
        <ModalFooter>
            <ButtonGroup size="xs">
                <Show visible={fiscal.data?.status !== Enums.FiscalNoteStatus.GENERATED}>
                    <Button children="Anexar nota" colorScheme="blue" onClick={attach.onOpen} />
                </Show>
                <IconButton icon="refresh" isLoading={fiscal.isFetching} onClick={fiscal.refetch} />
                <Dev data={fiscal} />
            </ButtonGroup>
        </ModalFooter>
    </Modal>

    <Attach {...attach} data={fiscal.data} onSuccess={fiscal.refetch} />
    </>
    )
}